export enum DeployedEnvironments {
  LMSDEV = 'LMS-DEV',
  LMSDEV2 = 'LMS-DEV2',
  LMSQA = 'LMS-QA',
  LMSUAT = 'LMS-UAT',
  LMSPROD = 'LMS-PROD',
}

export const DeployedEnvironmentsNameMapping: Record<DeployedEnvironments, string> = {
  [DeployedEnvironments.LMSDEV]: 'dev',
  [DeployedEnvironments.LMSDEV2]: 'dev2',
  [DeployedEnvironments.LMSQA]: 'qa',
  [DeployedEnvironments.LMSUAT]: 'uat',
  [DeployedEnvironments.LMSPROD]: 'prod',
} as const;
